<div class="mb-3 flex align-items-center" *ngIf="selectAll">
    <p-inputSwitch class="flex" [ngModel]="isAllChecked()" (onChange)="checkAll($event)" ariaLabelledBy="switch2"></p-inputSwitch>
    <p class="m-0 ml-2" id="switch2">Selecionar todas</p>
</div>
<div class="grid w-0">
    <div class="col-4" *ngFor="let value of data">
        <div class="card" (click)="onClickCard($event, value)" [ngClass]="{'checked': value.checklist}">
            <div  class="card-header mb-1 flex align-items-center justify-content-end">
                <p-checkbox [ngModel]="value.checklist" [binary]="true" inputId="binary"></p-checkbox>
            </div>
            <div class="card-body my-2 flex align-items-center justify-content-between" *ngFor="let card of cards; let i = index">
                <ng-container
                    *ngTemplateOutlet="card; context: { value }">
                </ng-container>
            </div>
        </div>
    </div>
</div>